import React from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const modules = {
  toolbar: [
    [{ header: [1, 2, false] }],
    ['bold', 'underline', 'strike'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    ['link'],
  ],
};
const formats = ['header', 'bold', 'underline', 'strike', 'list', 'bullet', 'link'];

export default function RichTextEditor({
  value,
  onChange,
  maxLength,
  editorStyle = {},
}) {
  const textOnlyLength = (value || '').replace(/<[^>]+>/g, '').length;

  // Height for the editable area only — the toolbar sits above it and adds
  // its own ~42px, so we no longer set height on the outer ReactQuill wrapper.
  const editorHeight = editorStyle.height || editorStyle.minHeight || 160;

  return (
    <>
      <div
        className="quill-wrapper"
        style={{
          display: 'flex',
          flexDirection: 'column',
          maxHeight: '100%',
          minHeight: 0,
        }}
      >
        <ReactQuill
          theme="snow"
          value={value}
          onChange={onChange}
          modules={modules}
          formats={formats}
          bounds=".quill-wrapper"
          style={{ marginBottom: 8 }}
        />
      </div>

      <style>{`
        .quill-wrapper .ql-container {
          height: ${editorHeight}px;
          overflow-y: auto;
        }
      `}</style>

      {typeof maxLength === 'number' && (
        <div
          style={{
            fontSize: 12,
            color: textOnlyLength >= maxLength ? 'red' : 'gray',
          }}
        >
          {textOnlyLength}/{maxLength}
        </div>
      )}
    </>
  );
}